import { render, staticRenderFns } from "./VarModal.vue?vue&type=template&id=23d09316&scoped=true&"
import script from "./VarModal.vue?vue&type=script&lang=js&"
export * from "./VarModal.vue?vue&type=script&lang=js&"
import style0 from "./VarModal.vue?vue&type=style&index=0&id=23d09316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d09316",
  null
  
)

export default component.exports